import { FC, PropsWithChildren, useRef } from 'react'
import { motion, useInView } from 'framer-motion'

export enum SlideInDirection {
  left = 'left',
  right = 'right',
}

const SlideInMotion:FC<
  PropsWithChildren<{
    direction:SlideInDirection,
    delay?:number,
  }>
> = ({
  direction,
  delay = 0,
  children,
}) => {
  const { left } = SlideInDirection

  const ref = useRef(null)
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px',
  })

  return (
    <motion.div
      ref={ref}
      initial={{
        x: direction === left
          ? -100
          : 100,
        opacity: 0,
      }}
      animate={
        isInView
          ? { x: 0, opacity: 1 }
          : { opacity: 0 }
      }
      transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay,
      }}
    >
      {children}
    </motion.div>
  )
}

export default SlideInMotion
